// extracted by mini-css-extract-plugin
export var accordion = "_bk-0";
export var chevron = "_bk-3";
export var closed = "_bk-2";
export var content = "_bk-4";
export var open = "_bk-1";
export var rotate = "_bk-5";